<template>
  <div>
    <el-card>
      <page-main
        :tableData="tableData"
        :tablePage="page"
        :loading="loading"
        @reload="reload"
        @openEditFormDialog="openEditFormDialog"
      >
        <page-header
          ref="header"
          slot="header"
          @query="getData"
          @reset="resetPage"
          @openEditFormDialog="openEditFormDialog"
        />
        <pagination
          size="mini"
          align="right"
          slot="pager"
          :layouts="[
            'Total',
            'Sizes',
            'PrevPage',
            'NextPage',
          ]"
          :current-page="page.curPage"
          :page-size="page.pageSize"
          :page-total="page.pageTotal"
          @change="handlePaginationChange"
        />
      </page-main>
      <el-dialog
        v-if="editFormDialogOptions.visible"
        show-close
        visible
        width="700px"
        :title="editFormDialogOptions.title"
        :close-on-click-modal="false"
        :before-close="() => $refs.editForm.cancel()"
      >
        <sample-edit-form
          ref="editForm"
          :metadataCode="editFormDialogOptions.metadataCode"
          :disabled="editFormDialogOptions.disabled"
          :params="editFormDialogOptions.params"
          @reload="reload"
          @close="closeEditFormDialog"
        />
        <span slot="footer">
          <el-button size="small" @click="$refs.editForm.cancel()"
            >{{this.$l('INDEX.btn_cancel') || '取消'}}</el-button
          >
          <el-button type="primary" size="small" @click="$refs.editForm.save()" v-if="!editFormDialogOptions.disabled"
            >{{this.$l('INDEX.btn_save') || '保存'}}</el-button
          >
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import SampleEditForm from '../edit-form/index'
import store from '../../store'
export default {
  components: {
    PageMain,
    PageHeader,
    SampleEditForm
  },
  mixins: [BaseTable],
  data() {
    return {
      usePage: true,
      editFormDialogOptions: {
        visible: false,
        metadataCode: '',
        companyCode: '',
      },
    }
  },
  computed: {
    selected() {
      return store.state.selected
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .sampleMetadataListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
          store.commit('setSelected', this.tableData[0])
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFormDialog({type, params = {}}) {
      const types = {
        edit: this.$l('form_label_metadata_edit') ||'编辑样品属性信息',
        add: this.$l('form_label_metadata_add') ||'添加样品属性信息',
        detail: this.$l('form_label_metadata_detail') ||'样品属性信息详情',
      }
      this.editFormDialogOptions = {
        visible: true,
        type,
        title: types[type],
        metadataCode: params.metadataCode,
        disabled: type === "detail",
      }
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false
    },
  },
}
</script>
